import { Tabs } from '@mui/material';

import { useBillingTabsStyles } from './useBillingTabsStyles';

export interface BillingTabsProps<Value> {
  children: React.ReactNode;
  onChange: (event: React.SyntheticEvent, newValue: Value) => void;
  value: Value;
}

export function BillingTabs<Value>({
  children,
  onChange,
  value,
}: BillingTabsProps<Value>) {
  const { classes } = useBillingTabsStyles();

  return (
    <Tabs
      classes={classes}
      indicatorColor="primary"
      onChange={onChange}
      value={value}
    >
      {children}
    </Tabs>
  );
}
